module.exports = __webpack_public_path__ + "img/chalice-purple.7e9b369e.svg";